import React, {useEffect, useState} from "react";
import Container from "@mui/material/Container";
import {
    Head,
    Loading,
    ProductAutoComplete,
    UserAutocomplete,
    UserCreate,
    UserEdit,
    UserPassword
} from "../../components";
import {Box, Tooltip} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import ReactPaginate from "react-paginate";
import IconButton from "@mui/material/IconButton";
import SyncIcon from "@mui/icons-material/Sync";
import moment from "moment-jalaali";
import {useSelector} from "react-redux";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MarketerList from "../../components/marketerList/marketerList";
import queryString from 'query-string';

const Commission = () => {

    const AppState = useSelector(state => state);
    const [open, setOpen] = React.useState(false);




    const history = useNavigate();
    const location = useLocation();

    const query = queryString.parse(location.search);
    const [params, setParams] = useState({
        page: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 100,
        status:query.status ? parseInt(query.status) : 0,
        parent_id: query.parent_id ? parseInt(query.parent_id) : '',
        name: query.name ? query.name : '',
        username:query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        mobile: query.mobile ? query.mobile : '',
    });
    const [loading, setLoading] = useState(true);
    const [searchTime, setSearchTime] = useState("");
    const [response, setResponse] = useState([]);
    const [commission, setCommission] = useState([]);
    const [ShowImg, setShowImg] = useState(false);
    const [img, setImg] = useState('')
    const [form, setForm] = useState({})
    const [marketerList, setMarketerList] = useState([])





    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        let obj = {
            "form": "commission_store",
            "marketer_id": form.marketer_id,
            "default": form.marketer_id ? 0 : 1,
            ...form
        }

        setLoading(true);
        new Api().post(`/marketers/contract/commission`, obj, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    handleCommision()
                } else {
                    toast.error(response.msg);
                }
            }
            setOpen(false)
            setLoading(false);
        })

    }


    const handleCommision = () => {
        new Api().get('/marketers/contract/commission', {
            form: "get_commission",
        }).then((response) => {
            if (typeof response !== "undefined") {
                setCommission(response);
            }

            setLoading(false);
        })
    }

    const handleMarketerList = () => {
        new Api().get('/marketers/autocomplete').then((response) => {
            if (typeof response !== "undefined") {
                setMarketerList(response);
            }

            setLoading(false);
        })
    }


    const handleChangeElement = (event) => {
        let frm = {...form};

        const word = event.target.value;
        const name = event.target.name;

        if (searchTime) {
            clearTimeout(searchTime)
        }
        let loop = setTimeout(()=>{

            frm[name] = word;
            setForm(frm);

        },50);

        setSearchTime(loop);


    };


    const handleChangeMarketer = (name , value) => {
        let frm = {...form};

        const word = value;


        if (searchTime) {
            clearTimeout(searchTime)
        }
        let loop = setTimeout(()=> {

            frm[name] = word;
            setForm(frm);

        },50);

        setSearchTime(loop);


    };


    useEffect(() => {

        handleCommision()
        handleMarketerList()

    } ,[])

    useEffect(() => {


        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.page,
        params.limit,
        params.status,
        params.parent_id,
        params.name,
        params.username,
        params.national_code,
        params.mobile,
    ]);




    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'page':
                    if (n_params.page !== parseInt(query.page)) {
                        n_params.page = parseInt(query.page);
                    }
                    break;
                case 'sort_field':
                    if (n_params.sort_field !== query.sort_field) {
                        n_params.sort_field = query.sort_field;
                        n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                    }
                    break;
                case 'limit':
                    if (n_params.limit !== parseInt(query.limit)) {
                        n_params.limit = parseInt(query.limit);
                    }
                    break;
                case 'id':
                    if (n_params.id !== query.id) {
                        n_params.id = query.id;
                    }
                    break;
                case 'status':
                    if (n_params.status !== query.status) {
                        n_params.status = query.status;
                    }
                    break;
                case 'from_date':
                    if (n_params.from_date !== query.from_date) {
                        n_params.from_date = query.from_date;
                    }
                    break;
                case 'to_date':
                    if (n_params.to_date !== query.to_date) {
                        n_params.to_date = query.to_date;
                    }
                    break;
                case 'user_id':
                    if (n_params.user_id !== query.user_id) {
                        n_params.user_id = query.user_id;
                    }
                    break;
                case 'parent_id':
                    if (n_params.parent_id !== query.parent_id) {
                        n_params.parent_id = query.parent_id;
                    }
                    break;
                case 'name':
                    if (n_params.name !== query.name) {
                        n_params.name = query.name;
                    }
                    break;
                case 'username':
                    if (n_params.username !== query.username) {
                        n_params.username = query.username;
                    }
                    break;
                case 'national_code':
                    if (n_params.national_code !== query.national_code) {
                        n_params.national_code = query.national_code;
                    }
                    break;
                case 'mobile':
                    if (n_params.mobile !== query.mobile) {
                        n_params.mobile = query.mobile;
                    }
                    break;
                case 'transport':
                    if (parseInt(n_params.transport) !== parseInt(query.transport)) {
                        n_params.transport = parseInt(query.transport);
                    }
                    break;
                case 'delivery':
                    if (n_params.delivery !== query.delivery) {
                        n_params.delivery = query.delivery;
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.page,
        query.limit,
        query.status,
        query.parent_id,
        query.name,
        query.username,
        query.national_code,
        query.mobile,
    ]);


    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = value;
                break;
            case 'limit':
                n_params.limit = value;
                break;
            case 'status':
                n_params.status = value;
                break;
            case 'parent_id':
                n_params.parent_id = value;
                break;
            case 'name':
                n_params.name = value;
                break;
            case 'username':
                n_params.username = value;
                break;
            case 'national_code':
                n_params.national_code = value;
                break;
            case 'mobile':
                n_params.mobile = value;
                break;

        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;
        url += `&limit=${n_params.limit}`;
        url += `&parent_id=${n_params.parent_id}`;
        url += `&name=${n_params.name}`;
        url += `&username=${n_params.username}`;
        url += `&national_code=${n_params.national_code}`;
        url += `&mobile=${n_params.mobile}`;
        url += `&status=${n_params.status}`;


        history(`/contract/${url}`);

    };


    const pageCount = Math.ceil(parseInt(commission?.details?.list?.total) / parseInt(commission?.details?.list?.per_page));

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': ' قرارداد کمیسیون بازاریاب ها', 'description': '' }} />

            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>

                <Tooltip title="افزودن" onClick={() => handleClickOpen()}>
                    <IconButton>
                        <ControlPointIcon/>
                    </IconButton>
                </Tooltip>

                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                >
                    <form onSubmit={handleSubmit} className='animate__animated animate__fadeIn' encType="multipart/form-data">
                        <DialogTitle id="alert-dialog-title">ایجاد قرارداد جدید</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>

                                <Divider />
                                <Grid item xs={12}>
                                    <TextField
                                        style={{ marginTop: '25px'}}
                                        label="حداقل فروش ماهیانه"
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='minimum_monthly_sales'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        autoComplete={"off"}
                                    />
                                    <TextField
                                        style={{ marginTop: '25px'}}
                                        label="درصد فروش عمده محصولات "
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='percent_of_major_products'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        autoComplete={"off"}
                                    />
                                    <TextField
                                        style={{ marginTop: '25px'}}
                                        label="درصد فروش خرده محصولات "
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='percent_of_retail_products'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        autoComplete={"off"}
                                    />
                                    <TextField
                                        style={{ marginTop: '25px'}}
                                        label="درصد فروش خرده محصولات بالاسری"
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='parent_percent_major_products'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        autoComplete={"off"}
                                    />
                                    <TextField
                                        style={{ marginTop: '25px'}}
                                        label="درصد فروش خرده محصولات بالاسری"
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='parent_percent_retail_products'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        autoComplete={"off"}
                                    />
                                    <div   style={{ marginTop: '25px'}}>
                                        <MarketerList label={"بازاریاب مورد نظر (اختیاری) "} onChange={(e) => handleChangeMarketer("parent_id" , e.id)}/>
                                    </div>

                                </Grid>
                                <Divider />
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                بستن
                            </Button>
                            <Button disabled={loading} type={'submit'} color="primary" autoFocus>
                                ارسال اطلاعات
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>

                <Tooltip title="سینک" onClick={() => handleCommision()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>

            </div>

            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>کد بازاریابی</th>
                        <th>حداقل فروش ماهیانه</th>
                        <th>درصد فروش عمده محصولات </th>
                        <th>درصد فروش خرده محصولات </th>
                        <th>درصد فروش عمده محصولات بالاسری</th>
                        <th>درصد فروش خرده محصولات بالاسری</th>
                        <th>تاریخ ایجاد</th>
                        <th>وضعیت</th>
                        {/*<th>عملیات</th>*/}
                    </tr>
                    </thead>
                    <tbody>
                    {commission?.details?.list?.data?.map((item, index) => {
                        return(
                            <tr>
                                <td>{index + 1}</td>
                                <td>{item.marketer_id || "---"}</td>
                                <td>{item.minimum_monthly_sales || "---"}</td>
                                <td>{item.percent_of_major_products || "---"}</td>
                                <td>{item.percent_of_retail_products || "---"}</td>
                                <td>{item.parent_percent_of_major_products || "---"}</td>
                                <td>{item.parent_percent_of_retail_products || "---"}</td>
                                <td style={{ direction: 'ltr'}}>{moment(item.created_at).locale('fa').format('jYYYY/jMM/jDD')}</td>
                                <td style={{ direction: 'ltr'}}><b className={'status-' + item.status}>{AppState.marketer.document_status && AppState.marketer.document_status[item.status]}</b></td>
                                {/*<td>*/}
                                {/*    <Button onClick={() => history.push('/contract/' + item.marketer_id)} size={"small"} color={"primary"} variant={"outlined"}>مشاهده</Button>&nbsp;*/}
                                {/*</td>*/}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
            <Dialog
                open={ShowImg}
                onClose={() => setShowImg(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <img style={{ borderRadius: 0, maxHeight: 300}} src={img}/>
            </Dialog>
        </Container>
    );

}

export default Commission;